import {PlacesBase} from './api-common.ts';
import {BASE_API_URL} from '../envs.ts';
import type {FeatureLike} from 'ol/Feature';

export class Travelreport extends PlacesBase {
  url: string;

  constructor(data: Travelreport | FeatureLike) {
    super(data);
    if (typeof (<FeatureLike>data).get === 'function')
      this.url = (<FeatureLike>data).get('url_travelreport');
    else Object.assign(this, <Travelreport>data);
  }
}

export async function fetchTravelreports(
  ids: number[],
): Promise<Travelreport[]> {
  const response = await fetch(
    `${BASE_API_URL}/api/4/feature/travelreport/${ids.join(',')}`,
  );
  return (await response.json()).map(
    (travelreport: Travelreport) => new Travelreport(travelreport),
  );
}
